"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
exports.Routes = {
    Home: {
        path: '/',
        name: 'home',
        isHeaderActionsShow: true,
    },
    Registration: {
        path: '/registration',
        name: 'registration',
        isHeaderActionsShow: false,
    },
    Registered: {
        path: '/successfully-registered',
        name: 'successfully-registered',
        isHeaderActionsShow: false,
    },
    Verify: {
        path: '/verify',
        name: 'verify',
        isHeaderActionsShow: false,
    },
    VerificationFailed: {
        path: '/verification-failed',
        name: 'verification-failed',
        isHeaderActionsShow: false,
    },
    ForgotPassword: {
        path: '/forgot-password',
        name: 'forgot-password',
        isHeaderActionsShow: false,
    },
    ResetPassword: {
        path: '/reset-password/:hash',
        name: 'reset-password',
        isHeaderActionsShow: false,
    },
    TermsAndConditions: {
        path: '/terms-conditions',
        name: 'terms-conditions',
        isHeaderActionsShow: true,
    },
    PrivacyPolicy: {
        path: '/privacy-policy',
        name: 'privacy-policy',
        isHeaderActionsShow: true,
    },
    AboutUs: {
        path: '/about-us',
        name: 'about-us',
        isHeaderActionsShow: true,
    },
    ContactUs: {
        path: '/contact-us',
        name: 'contact-us',
        isHeaderActionsShow: true,
    },
    Subscription: {
        path: '/subscription',
        name: 'subscription',
        isHeaderActionsShow: true,
    },
    Announcement: {
        path: '/announcement',
        name: 'announcement',
        isHeaderActionsShow: true,
    },
    EditAnnouncement: {
        path: '/announcement/:id',
        name: 'announcement',
        isHeaderActionsShow: true,
    },
    Account: {
        path: '/account',
        name: 'account',
        isHeaderActionsShow: true,
    },
    Wishlist: {
        path: '/wishlist',
        name: 'wishlist',
        isHeaderActionsShow: true,
    },
    Help: {
        path: '/help',
        name: 'help',
        isHeaderActionsShow: true,
    },
    Support: {
        path: '/support',
        name: 'support',
        isHeaderActionsShow: true,
    },
    SavedSearches: {
        path: '/saved-searches',
        name: 'saved-searches',
        isHeaderActionsShow: true,
    },
    Settings: {
        path: '/settings',
        name: 'settings',
        isHeaderActionsShow: true,
    },
    Statistics: {
        path: '/account/announcements/:id/statistics',
        name: 'statistics',
        isHeaderActionsShow: true,
    },
    Homes: {
        path: '/search',
        name: 'search',
        isHeaderActionsShow: true,
    },
    Rent: {
        path: '/rent',
        name: 'rent',
        isHeaderActionsShow: true,
    },
    Sell: {
        path: '/sell',
        name: 'sell',
        isHeaderActionsShow: true,
    },
    SmsVerification: {
        path: '/sms-verify',
        name: 'sms-verify',
        isHeaderActionsShow: true,
    },
    SmsVerificationCode: {
        path: '/sms-code',
        name: 'sms-code',
        isHeaderActionsShow: true,
    },
    SmsVerificationSuccess: {
        path: '/sms-success',
        name: 'sms-success',
        isHeaderActionsShow: true,
    },
    EssentialTips: {
        path: '/essential-tips',
        name: 'essential-tips',
        isHeaderActionsShow: true,
    },
    PaymentConfirmation: {
        path: '/payment-confirmation/:status',
        name: 'payment-confirmation',
        isHeaderActionsShow: true,
    },
};
